import { IconProps } from "./types";

export const UserIcon = (props: IconProps) => (
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 29" fill="none">
  <circle cx="10" cy="5.375" r="3.5" stroke={props.color || "#8B90B3"} strokeWidth="3"/>
  <path d="M6.92814 14.875C8.27529 12.5417 11.6432 12.5417 12.9903 14.875L17.8081 23.2197L9.95923 26.9631L2.11034 23.2197L6.92814 14.875Z" stroke={props.color || "#8B90B3"} strokeWidth="3"/>
</svg>
);
